export default __webpack_public_path__ + "static/media/Flunapen-150-eng.2308dd15.jpg";